import React, { useContext, useState, useEffect } from "react";
import {
  Box,
  Flex,
  HStack,
  Button,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Avatar,
  useColorModeValue,
  IconButton,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import { Link as RouterLink, NavLink, useNavigate } from "react-router-dom";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { AuthContext } from "../context/AuthProvider";
import { PeerxLogo } from "./icons/Icons"; // Assuming custom logo component
import { SidebarContext } from "../context/SidebarContext";


const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { user, logOut } = useContext(AuthContext); // Access user and logOut from AuthProvider
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Local state for authentication status

  useEffect(() => {
    // Update isAuthenticated whenever user changes
    setIsAuthenticated(!!user);
  }, [user]);

  const handleLogout = async () => {
    try {
      await logOut(); // Call the logOut function from AuthProvider
      navigate("/auth/sign-in"); // Redirect to sign-in after logout
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <SidebarContext.Provider>
    <Box
      bg={useColorModeValue("white", "gray.900")}
      px={4}
      shadow="sm"
      zIndex="10"
      position="fixed"
      w="100%"
    >
      {/* Navbar Main Content */}
      <Flex h={16} alignItems="center" justifyContent="space-between">
        {/* Hamburger Menu for Mobile */}
        <IconButton
          size="md"
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label="Open Menu"
          display={{ md: "none" }}
          onClick={isOpen ? onClose : onOpen}
        />

        {/* Brand Logo */}
        <HStack spacing={8} alignItems="center">
          <Flex as={RouterLink} to="/" alignItems="center">
            <PeerxLogo h="30px" w={200} />
          </Flex>
        </HStack>

        {/* User Menu or Authentication Options */}
        <Flex alignItems="center">
          {isAuthenticated ? (
            <Menu>
              <MenuButton
                as={Button}
                rounded="full"
                variant="link"
                cursor="pointer"
              >
                <Avatar
                  size="md"
                  src={user?.photoURL || ""}
                  name={user?.displayName || "User"}
                />
              </MenuButton>
              <MenuList>
                <MenuItem as={RouterLink} to="/personal/profile">
                  Profile
                </MenuItem>
                <MenuItem onClick={handleLogout}>Log Out</MenuItem>
              </MenuList>
            </Menu>
          ) : (
            <HStack spacing="4">
              {/* Log In Link */}
              <NavLink to="/auth/sign-in">
                <Text
                  fontSize="md"
                  fontWeight="600"
                  _hover={{ color: "purple.500" }}
                >
                  Log In
                </Text>
              </NavLink>
              {/* Sign Up Button */}
              <NavLink to="/auth/sign-up">
                <Button
                  bg="purple.500"
                  color="white"
                  fontWeight="bold"
                  px="16px"
                  borderRadius="20px"
                  _hover={{ bg: "purple.400" }}
                >
                  Sign Up
                </Button>
              </NavLink>
            </HStack>
          )}
        </Flex>
      </Flex>

      {/* Mobile Navigation Links */}
      {isOpen ? (
        <Box pb={4} display={{ md: "none" }}>
          <Stack as="nav" spacing={4}>
            {/* Add mobile navigation links here */}
          </Stack>
        </Box>
      ) : null}
    </Box>
    </SidebarContext.Provider>
  );
};

export default Navbar;
